import React, {Component} from 'react';
import {connect} from "react-redux";
import 'react-bootstrap';

import informationApi from "../../../api/informationApi";
import store from '../../../store/configureStore';
import { addNotification } from "../../../actions/notificationAction";
import {changeHomeSectionAction} from '../../../actions/homeSectionAction';
import { lang } from '../../../config/lang';
import InformationBlock from './InformationBlock';
import { Businesses } from '../../../config/Helper';
import $ from "jquery"

class InformationSlider extends Component {

    constructor(props)
    {
        super(props);
        this.state = {
            arrInfo: []
        };
        this.initSlider = this.initSlider.bind(this);
        this.refreshSlider = this.refreshSlider.bind(this);
        this.isArray = this.isArray.bind(this);
        this.getInformations = this.getInformations.bind(this);
    }

    componentWillMount() { 
        
    }

    componentDidMount() {
        this.getInformations(true);        
        window.contentWayPoint();

    }
  
    componentWillUnmount() {
        
    }
    
    componentDidUpdate() {
        
    }

    componentWillReceiveProps(newProps) {
        this.getInformations(false);
    }   

    initSlider() {
        window.initInfoSlider();                
        window.contentWayPoint();
    }

    refreshSlider() {
        window.refreshInfoSlider();
    }

    isArray(what) {
        return Object.prototype.toString.call(what) === '[object Array]';
    }

    getInformations(isNew) {
                
        informationApi.getInformations().then((json) => {
            
            if (json.status === 200) {
                var informations = this.isArray(json.data) ? json.data : [];                
                this.setState({
                    arrInfo: informations
                });

                if (informations.length > 0) {
                    store.dispatch(changeHomeSectionAction({information: true}));
                }
                
                if (isNew) {
                    setTimeout(this.initSlider, 400);
                } else {
                    setTimeout(this.refreshSlider, 400);
                }
            } else {
                store.dispatch(addNotification(`${lang('server_err')}`, 'error'));
            }            
        })
    }
  
    render() {

        if (this.state.arrInfo.length === 0) {
            return (
                <div />
            );
        }

        var couplingArrInfo = [];
        var couplingItem = [];
        
        for (var i = 0; i < this.state.arrInfo.length; i++) {            

            couplingItem.push(this.state.arrInfo[i]);

            if (couplingItem.length === 2 ||
                i === this.state.arrInfo.length - 1) {   
                couplingArrInfo.push(couplingItem);
                couplingItem = [];
            }
        }

        return (
            <section id="information-section" className="ftco-section testimony-section"  data-aos="fade">
                <div className="container">
                    <div className="row justify-content-center heading" style={{marginBottom: '10px !important'}}>
                        <div className="col-md-7 heading-section text-center ftco-animate">
                            <h2 className="mb-4">{this.props.title}</h2>
                            <p>{this.props.sub_title}</p>
                        </div>
                    </div>
                </div>

                <div className="container">
                    <div className="row justify-content-start">
                        <div className="col-md-12 heading-section ftco-animate">
                            <div className="row ftco-animate align-items-stretch no-gutters service-news">
                                <div className="col-md-12">
                                    <div className="slide-one-item owl-carousel service-information">
                                    {
                                        couplingArrInfo.map((coupleItem, key) => (
                                            <div key={key} className="testimonial col-sm-6 col-md-4 mb-4 mb-lg-0 col-lg-3">
                                                <InformationBlock
                                                    business={Businesses.indexOf('information')}
                                                    id={coupleItem[0].id}
                                                    title={coupleItem[0].title}
                                                    icon={coupleItem[0].icon}
                                                />
                                                {
                                                coupleItem.length === 2 &&
                                                <InformationBlock
                                                    business={Businesses.indexOf('information')}
                                                    id={coupleItem[1].id}
                                                    title={coupleItem[1].title}
                                                    icon={coupleItem[1].icon}
                                                />
                                                }
                                            </div>
                                        ))
                                    }
                                    
                                    </div>
                					        
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

function mapStateToProps(state) {
    return { 
        language: state.language
    };
}

export default connect(mapStateToProps)(InformationSlider);